import React from 'react';
import { GetStaticProps, NextPage } from 'next';
import { useRouter } from 'next/router';

import { googleSignUp } from '@api/auth/googleSingUp';
import { SignUp } from '@components/authorization/signUp';
import { getSeoMetadata, TSeoFields } from '@api/global/getSeoMetadata';
import MetaHead from '@components/_shared/metaHead';

type StaticProps = {
  props: {
    seoMetadata: TSeoFields;
  };
};

const SignUpPage: NextPage<StaticProps['props']> = (props) => {
  const { seoMetadata } = props;
  const router = useRouter();

  const onBackClick = () => router.back();
  const onSignInClick = () => router.replace('login');
  const onSignUpWithEmailClick = () =>
    router.query.token
      ? router.push(
          `your-info?token=${router.query.token}&email=${router.query.email}&first_name=${router.query.first_name}&last_name=${router.query.last_name}`
        )
      : router.push('your-info');

  return (
    <>
      <MetaHead {...seoMetadata} />

      <div>
        <SignUp
          onBackClick={onBackClick}
          onGoogleSignUpClick={() =>
            googleSignUp('', (router.query.token as string) || undefined)
          }
          onSignUpWithEmailClick={onSignUpWithEmailClick}
          onSignInClick={onSignInClick}
        />
      </div>
    </>
  );
};

export const getStaticProps: GetStaticProps<any> = async () => {
  try {
    const seoMetadata = await getSeoMetadata();
    return {
      props: {
        seoMetadata: {
          title: seoMetadata?.signupPage?.title || 'Sign Up',
          description: seoMetadata?.signupPage?.description || '',
          ogImage: seoMetadata?.signupPage?.ogImage || '',
        },
      },
    };
  } catch (error) {
    return {
      props: {
        seoMetadata: {
          title: 'Sign Up',
          description: '',
          ogImage: '',
        },
      },
    };
  }
};

export default SignUpPage;
